module.exports = __webpack_public_path__ + "static/img/m8.ec6db3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m8.jpg
// module id = 6U43
// module chunks = 1